import { render, staticRenderFns } from "./interface-config.vue?vue&type=template&id=15610b04&"
import script from "./interface-config.vue?vue&type=script&lang=js&"
export * from "./interface-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports